import React from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';

class LocationSearchInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { address: "" };
  }
 
  handleChange = address => {
    // onGoogleLocChange CALLED FRON keyLocationComponent 
    if((this.props.resetLocNameErr) && this.props.resetLocNameErr==='yes') this.props.onGoogleLocChange(address); 
    this.setState({ address });
  };
 
  handleSelect = address => {
    this.setState({ address });
    this.props.googleLocSelect(address);
  };

  componentDidUpdate(prevProps) {
    let resetGoogleLocation = 0; 
    if(this.props.hasOwnProperty('resetGoogleLocation')) {
      resetGoogleLocation = this.props.resetGoogleLocation; 
      if (resetGoogleLocation !== prevProps.resetGoogleLocation) {            
        this.setState({ address:'' });
      }
    } 
  }

 
  render() {
    return (
      <PlacesAutocomplete
        value={this.state.address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
        shouldFetchSuggestions={this.state.address.length >1}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <input
              {...getInputProps({
                placeholder: 'Search Places from Google...',
                className: 'location-search-input form-control '+this.props.className,
                name: 'googleLocation',
                disabled:this.props.disabled?'disabled':''
              })}
            />
            <div className="autocomplete-dropdown-container">
              {loading && <div className="loading-loc">Loading...</div>}
              {suggestions.map((suggestion, index) => {
                const className = suggestion.active ? 'loc-item suggestion-item--active' : 'loc-item suggestion-item';
                // inline style for demonstration purpose
                const style = suggestion.active
                  ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                  : { backgroundColor: '#ffffff', cursor: 'pointer' };
                return (
                  <React.Fragment key={'gLoc_'+index}>
                  <div 
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    );
  }
}

export default LocationSearchInput;